import { createContext } from 'react'

interface ProjectFormContextProps {
  projectId?: string
  projectFormId?: string
  requestSave?: () => void
}

export const ProjectFormContext = createContext<ProjectFormContextProps>({})
